import React from 'react';

/**
 * props:
 * - id
 * - value
 * - onChange
 * - hint
 */
function MaxOpenPositionsField({ id = 'maxOpenPositions', value, onChange, hint }) {
    return (
        <div className="form-group mb-3">
            <label htmlFor={id}>Max open positions</label>
            <input
                id={id}
                type="number"
                min="0"
                step="1"
                className="form-control"
                value={value ?? 0}
                onChange={onChange}
            />
            <small className="text-muted d-block mt-1">
                {hint || '0 = unlimited. Counts filled open positions (buys minus sells), not pending orders.'}
            </small>
        </div>
    );
}

export default MaxOpenPositionsField;